export default "__VITE_ASSET__D5QJS4As__"